import type { ReactNode } from 'react';

/* Styled Components */
import {
  Title,
  ColumnWrapper,
  ContentWrapper,
  TextBox as StyledTextBox,
} from 'styles/signup/BlueTextBox';

type PropsType = {
  title?: string | null;
  description?: string;
  icon?: ReactNode;
  margin?: string;
  onClick: () => void;
};

const TextBox = ({ title, description, icon, margin, onClick }: PropsType) => {
  return (
    <StyledTextBox margin={margin} onClick={onClick}>
      {icon}
      <ColumnWrapper>
        <Title>{title}</Title>
        <ContentWrapper>{description}</ContentWrapper>
      </ColumnWrapper>
    </StyledTextBox>
  );
};

export default TextBox;
